import {
  Companion_getInstance2zg1j1fxqbni0 as Companion_getInstance,
  Mask3fc1c3tjgnucb as Mask,
} from './Mask.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareMaskFields() {
  var tmp = Companion_getInstance().b2j(NothingSerializer());
  properties(tmp, prepareMaskFields$lambda);
}
function Mask_pairs$name$delegate$lambda() {
  return Companion_getInstance().b2j(NothingSerializer()).az().v11(0);
}
function Mask_pairs$_get_name_$ref_8jrcdv() {
  return (p0) => p0.i20();
}
function Mask_pairs$_get_serializer_$ref_si67h6() {
  return (p0) => p0.h2j();
}
function Mask_pairs$_get_annotations_$ref_nnf7dq() {
  return (p0) => p0.bz();
}
var Mask_pairsClass;
function Mask_pairs() {
  if (Mask_pairsClass === VOID) {
    class $ {
      constructor(t) {
        var tmp = this;
        tmp.c2j_1 = lazy(Mask_pairs$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d2j_1 = lazy(() => {
          var tmp = Companion_getInstance().b2j(t);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.e2j_1 = lazy(() => Companion_getInstance().b2j(t).az().x11(0));
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.f2j_1 = emptyList();
        this.g2j_1 = 'listOf()';
      }
      i20() {
        var tmp0 = this.c2j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Mask_pairs$_get_name_$ref_8jrcdv(), null);
        return tmp0.f2();
      }
      i2j(receiver) {
        return receiver.j2j_1;
      }
      k2j(receiver) {
        return this.i2j(receiver instanceof Mask() ? receiver : THROW_CCE());
      }
      l2j(receiver, value) {
        return receiver.m2j(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Mask() ? receiver : THROW_CCE();
        return this.l2j(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d2j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Mask_pairs$_get_serializer_$ref_si67h6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e2j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Mask_pairs$_get_annotations_$ref_nnf7dq(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -993288877;
      }
      equals(other) {
        return other instanceof Mask_pairs();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'Mask_pairs', VOID, VOID, [SerializableProperty()]);
    Mask_pairsClass = $;
  }
  return Mask_pairsClass;
}
function prepareMaskFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (Mask_pairs())(args[0])];
}
//region block: exports
export {
  prepareMaskFields as prepareMaskFields1vyea3qdqniax,
};
//endregion

//# sourceMappingURL=MaskFields.mjs.map
